// Función para normalizar strings y comparar sin mayúsculas, tildes ni espacios
export const normalizar = (str) =>
    str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase();